import React from 'react'
import { Card } from "react-bootstrap";


function CustomCard({ image, text }) {
  return (
    <>
      <Card className="mb-4 w-100 rounded-lg" style={{ cursor: 'pointer' }}>
        <Card.Img variant="top" src={image} className="img-fluid rounded-lg" style={{ maxHeight: '100%', height: '350px', width: '100%', backgroundColor: '#f2f2f0'}} />
        <Card.Body className="d-flex flex-column justify-content-between">
          <Card.Text className="text-center mt-2">{text}</Card.Text>
        </Card.Body>
      </Card>
    </>
  )
}

export default CustomCard